import type { FC } from "react";

import { DateTimePicker, type DateTimePickerLocale } from "@recobra/ui/custom/date-time-picker";

import { useLocale } from "../useLocale";
import { getErrorMessage, useFieldContext } from "./context";
import { FieldShell } from "./FieldShell";

export const DateTimeField: FC<{
  label: string;
  id?: string;
  colSpan?: 1 | 2;
  hint?: string;
  placeholder?: string;
  required?: boolean;
}> = ({ label, id, colSpan, hint, placeholder, required }) => {
  const field = useFieldContext<string | undefined>();
  const { locale } = useLocale();
  const pickerLocale: DateTimePickerLocale = locale === "pt-BR" ? "pt-BR" : "en";
  const errorMessage = getErrorMessage(field.state.meta.errors[0]);

  return (
    <FieldShell
      label={label}
      id={id}
      colSpan={colSpan}
      required={required}
      hint={hint}
      errorMessage={errorMessage}
    >
      <DateTimePicker
        id={id}
        value={field.state.value}
        onChange={(value) => field.handleChange(value)}
        onBlur={field.handleBlur}
        placeholder={placeholder}
        locale={pickerLocale}
        aria-invalid={Boolean(errorMessage)}
      />
    </FieldShell>
  );
};
